import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ArrayPopTools } from '../../../../shared/services/array-pop-tools';
import { Rectificatif } from '../models/Rectificatif';
import { TypeInfosRectif } from '../models/TypeInfosRectif';
@Component({
  selector: 'app-rectificatif',
  templateUrl: './rectificatif.component.html'
})
export class RectificatifComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Rectificatif'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	@Input() rectificatif : Rectificatif;

  constructor() { }

  public ngOnInit() {
  }
  
  
  addtypeInfosRectif(){
		this.rectificatif.infosRectif.push(new TypeInfosRectif());
	}
  
  removetypeInfosRectif(i){
		ArrayPopTools.pop(this.rectificatif.infosRectif, i, this.parentForm, this.getUid());
	}
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

